import { render, staticRenderFns } from "./Survey.vue?vue&type=template&id=a1a87aac&scoped=true&"
import script from "./Survey.vue?vue&type=script&lang=js&"
export * from "./Survey.vue?vue&type=script&lang=js&"
import style0 from "./Survey.vue?vue&type=style&index=0&id=a1a87aac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a87aac",
  null
  
)

/* custom blocks */
import block0 from "./Survey.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1a87aac')) {
      api.createRecord('a1a87aac', component.options)
    } else {
      api.reload('a1a87aac', component.options)
    }
    module.hot.accept("./Survey.vue?vue&type=template&id=a1a87aac&scoped=true&", function () {
      api.rerender('a1a87aac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-analysis/Survey.vue"
export default component.exports